import { useRouterState } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { Skeleton } from '@/shared/ui/skeleton'

import { AppShellSkeleton } from './app-shell-skeleton'

/**
 * Placeholder da primeira pintura. Enquanto o root está pendente, as rotas
 * filhas não renderizam o próprio `pendingComponent`; por isso a escolha é
 * feita pela URL: o login recebe um placeholder neutro (marca e linhas
 * centralizadas) e qualquer outra rota recebe o skeleton do shell.
 */
export function RootSkeleton() {
  const { t } = useTranslation()
  const pathname = useRouterState({ select: (state) => state.location.pathname })

  if (!pathname.startsWith('/login')) return <AppShellSkeleton />

  return (
    <div
      className="flex min-h-svh items-center justify-center bg-background p-4"
      role="status"
      aria-busy="true"
      data-testid="root-skeleton"
    >
      <span className="sr-only">{t('app.loading')}</span>
      <div className="flex w-full max-w-xs flex-col items-center gap-4">
        <Skeleton className="size-12" />
        <Skeleton className="h-5 w-40" />
        <Skeleton className="h-4 w-56" />
      </div>
    </div>
  )
}
